export enum ParcelState {
  Deleted = "deleted",
  Loaded = "loaded",
  Loosened = "loosened",
  Sent = "sent",
  Stored = "stored",
}
